import { createContext, useContext, type ReactNode } from 'react';
import type { LexApiClient } from '../index';

const ApiContext = createContext<LexApiClient | null>(null);

export function ApiProvider({ client, children }: { client: LexApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): LexApiClient {
  const ctx = useContext(ApiContext);
  if (!ctx) throw new Error('useApi must be used within <ApiProvider>');
  return ctx;
}
